import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {

  1: { // Exercise num
    unit: 'Unit 4',
    id: 'WB4-V2-U4-P32-E1',
    audio: '',
    video: '',
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page32/E1/1.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 4',
    id: 'WB4-V2-U4-P32-E2',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page32/E2/Key/answerKey.png',
    titleQuestion: [{ num: '2', title: 'Read again. Circle four things that students can do.', color: "#5B5A5D" }],
    question: {
      Write: {
        inputStyle: { width: 420 },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { border: 'solid 3px', borderRadius: '50%', borderColor: 'transparent' },
        selectWordStyle: { borderColor: '#4285F4' },
        // limitSelect: 1,
        listWords: [
          'At our school we have two big', //0 
          'school yards. This is my school ',
          'yard. It is for the 1st, 2nd, and 3rd ',
          'grade students. The 4th and 5th ',
          'grade students play in a different ',
          'school yard. ',

          'There are squares on the school',
          'yard where we can play games. The',
          'students can play with a ball and ',
          'run around. We can also talk to our',
          'friends. We love our school yard.',
        ],
        answers: ['7-8', '7-10', '8-4', '8-6', '8-8', '8-10', '9-2', '9-0', '9-10', '9-12', '9-14', '10-0'],
        initialValue: [],
      },
      Layout: `
      <div style="position: relative;">
        <img src="img/FriendsPlus/Page32/E2/1.jpg" />
        <div style="position: absolute;top:71px ;left:78px">
          <div> <input id='0' type='Circle' /></div>
          <div> <input id='1' type='Circle' /></div>
          <div> <input id='2' type='Circle' /></div>
          <div> <input id='3' type='Circle' /></div>
          <div> <input id='4' type='Circle' /></div>
          <div> <input id='5' type='Circle' /></div>
          <div> <input id='6' type='Circle' /></div>
          <div> <input id='7' type='Circle' /></div>
          <div> <input id='8' type='Circle' /></div>
          <div> <input id='9' type='Circle' /></div>
          <div> <input id='10' type='Circle' /></div>
        </div>
      </div>
      `,
    },
  },
  3: { // Exercise num
    unit: 'Unit 4',
    id: 'WB4-V2-U4-P32-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page32/E3/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page32/E3/1.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page32/E3/0.jpg' },
      ],

      [
        // Column1
        { url: 'img/FriendsPlus/Page32/E3/1a.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page32/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page32/E3/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page32/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page32/E3/5.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page32/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page32/E3/7.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page32/E3/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page32/E3/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page32/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page32/E3/11.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page32/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page32/E3/13.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page32/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page32/E3/15.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page32/E3/16.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page32/E3/17.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page32/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page32/E3/19.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page32/E3/20.jpg' },
        { url: 'img/FriendsPlus/Page32/E3/21.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page32/E3/22.jpg' },
        { url: 'img/FriendsPlus/Page32/E3/23.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page32/E3/24.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page32/E3/25.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page32/E3/25.jpg' },
      ],

    ]
  },

}

export default json;